<template>
  <li>
    <ul>
      <li v-for="measurementType in trackingGroup.MeasurementTypes">
        <h4 :title="measurementType.name">
          <span>{{ measurementType.abbreviation || measurementType.name }}</span>
        </h4>
        <span class="values">
          <span class="measurement-value">{{ measurementType.Measurement.value | number-format(2) }}</span><span class="measurement-unit">{{ measurementType.expressed_in_unit }}</span>
        </span>
      </li>
    </ul>
  </li>
</template>

<script>
import LabelGroupAbstract from './label-group-abstract';

export default {
  mixins: [LabelGroupAbstract],
  name: 'tracked-measurements-label-group-single',
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/participant-evolution/dashboard/tracked-measurements-label-groups/label-group-single.vue